export default "__VITE_ASSET__1280b995__"